export default __webpack_public_path__ + "728075351871f77f63e9d3e24a949901.svg";